module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("ZRxtC"))).then(() => parcelRequire('d0iPb'));